import { CampaignStatusSchema, CampaignType } from "@adlywise/shared";
import { toDateInputValue } from "@/utils/dateUtils";

const Status = CampaignStatusSchema.enum;

export const STATUSES = [
  { value: Status.draft, label: "Draft" },
  { value: Status.active, label: "Active" },
  { value: Status.paused, label: "Paused" },
  { value: Status.completed, label: "Completed" },
];

export const DEFAULT_TRANSIT = {
  entrypoint: "",
  margin: 0,
  qps: 1,
  selectedPublishers: [],
  blockList: [],
};

export const DEFAULT_CAMPAIGN = {
  name: "",
  description: "",
  status: Status.draft,
  type: CampaignType.Standard,
  selectedSegments: [],
  userId: "",
  defaultCreativeId: "",
  startDate: "",
  endDate: "",
  icon: null,
  cpm: 0,
  dailyFrequency: "",
  weeklyFrequency: "",
  impressionsCap: "",
  budgetCap: "",
  impressionDomain: null,
  metadata: { ...DEFAULT_TRANSIT },
};

export const toFormState = (campaign) => {
  if (!campaign)
    return { ...DEFAULT_CAMPAIGN, metadata: { ...DEFAULT_TRANSIT } };

  // Read metadata for both types, not transit-only: standard campaigns now also
  // persist `selectedPublishers` here, so editing must hydrate it to survive a
  // round-trip.
  const rawMeta =
    campaign.metadata && typeof campaign.metadata === "object"
      ? campaign.metadata
      : {};
  const isTransit = campaign.type === CampaignType.Transit;
  return {
    ...DEFAULT_CAMPAIGN,
    ...campaign,
    type: isTransit ? CampaignType.Transit : CampaignType.Standard,
    selectedSegments: Array.isArray(campaign.selectedSegments)
      ? campaign.selectedSegments
          .map(String)
          .filter((id) => id && id !== "undefined" && id !== "null")
      : [],
    defaultCreativeId: campaign.defaultCreativeId ?? "",
    startDate: toDateInputValue(campaign.startDate),
    endDate: toDateInputValue(campaign.endDate),
    cpm: campaign.cpm ?? 0,
    dailyFrequency:
      campaign.dailyFrequency != null ? String(campaign.dailyFrequency) : "",
    weeklyFrequency:
      campaign.weeklyFrequency != null ? String(campaign.weeklyFrequency) : "",
    impressionsCap:
      campaign.impressionsCap != null ? String(campaign.impressionsCap) : "",
    budgetCap: campaign.budgetCap != null ? String(campaign.budgetCap) : "",
    impressionDomain: campaign.impressionDomain ?? null,
    metadata: {
      entrypoint: isTransit ? (rawMeta.entrypoint ?? "") : "",
      margin: isTransit ? (rawMeta.margin ?? 0) : 0,
      qps: isTransit ? (rawMeta.qps ?? 1) : 1,
      selectedPublishers: Array.isArray(rawMeta.selectedPublishers)
        ? rawMeta.selectedPublishers
        : [],
      blockList: isTransit
        ? Array.isArray(rawMeta.blockList)
          ? rawMeta.blockList
          : []
        : [],
    },
  };
};

export const toNullableInt = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};

export const toNullableFloat = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
